"use client";

import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Bot, Globe, PlugZap, CheckCircle2 } from "lucide-react";

/**
 * 3D-Bühne im Hintergrund + gestochen scharfes Andockmanöver im Vordergrund.
 */
export default function Preview() {
  const [docked, setDocked] = useState(false);

  useEffect(() => {
    const id = setInterval(() => setDocked((v) => !v), 2300);
    return () => clearInterval(id);
  }, []);

  return (
    <div
      aria-hidden="true"
      className="relative flex h-full w-full items-center justify-center overflow-hidden rounded-2xl p-4 select-none"
      style={{ perspective: "900px" }}
    >
      <motion.div
        animate={{
          scale: docked ? [1, 1.25, 1.1] : 0.85,
          opacity: docked ? 0.85 : 0.45,
        }}
        transition={{ duration: 0.8 }}
        className={`pointer-events-none absolute left-1/2 top-1/2 h-40 w-56 -translate-x-1/2 -translate-y-1/2 rounded-full blur-3xl transition-colors duration-500 ${
          docked ? "bg-emerald-500/35" : "bg-sky-500/30"
        }`}
      />

      <div
        className="pointer-events-none absolute inset-x-[-20%] bottom-[-35%] h-[110%] opacity-45 dark:opacity-60"
        style={{
          transform: "rotateX(68deg)",
          maskImage:
            "radial-gradient(ellipse 65% 55% at 50% 50%, black 25%, transparent 80%)",
          WebkitMaskImage:
            "radial-gradient(ellipse 65% 55% at 50% 50%, black 25%, transparent 80%)",
        }}
      >
        <motion.div
          animate={{ backgroundPosition: ["0px 0px", "0px 28px"] }}
          transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
          className="h-full w-full bg-[linear-gradient(to_right,rgba(16,185,129,0.28)_1px,transparent_1px),linear-gradient(to_bottom,rgba(16,185,129,0.28)_1px,transparent_1px)] bg-[size:28px_28px]"
        />
      </div>

      {/* Gestochen scharfer Vordergrund */}
      <div className="relative z-10 flex items-center gap-2 antialiased">
        <motion.div
          animate={{ x: docked ? 8 : -12 }}
          transition={{ type: "spring", stiffness: 280, damping: 22 }}
          className="flex items-center gap-2 rounded-2xl border border-purple-400/80 bg-white px-3.5 py-2.5 shadow-[0_14px_28px_-4px_rgba(168,85,247,0.5)] dark:bg-zinc-900"
        >
          <Bot className="h-4 w-4 text-purple-500" />
          <span className="font-sans text-xs font-black text-neutral-900 dark:text-white">
            Agent
          </span>
          <PlugZap
            className={`h-4 w-4 transition-colors ${
              docked ? "text-emerald-500" : "text-purple-400"
            }`}
          />
        </motion.div>

        <motion.div
          animate={{ x: docked ? -4 : 10 }}
          transition={{ type: "spring", stiffness: 280, damping: 22 }}
          className={`flex flex-col gap-1 rounded-2xl border bg-white px-3.5 py-2 transition-all duration-300 dark:bg-zinc-900 ${
            docked
              ? "border-emerald-400/80 shadow-[0_16px_32px_-4px_rgba(16,185,129,0.55)]"
              : "border-sky-400/60 shadow-md"
          }`}
        >
          <div className="flex items-center gap-1.5">
            <Globe className="h-3.5 w-3.5 text-sky-500" />
            <span className="font-sans text-xs font-black text-neutral-900 dark:text-white">
              Web-Tool
            </span>
          </div>
          <span className="flex items-center gap-1 font-mono text-[9px] font-bold text-emerald-600 dark:text-emerald-400">
            {docked ? (
              <>
                <CheckCircle2 className="h-3 w-3" />
                <span>Direkt-Call!</span>
              </>
            ) : (
              <span className="text-neutral-400">Bereit...</span>
            )}
          </span>
        </motion.div>
      </div>
    </div>
  );
}
